"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "backgroundAdded", {
  enumerable: true,
  get: function get() {
    return _backgroundAdded["default"];
  }
});
var _backgroundAdded = _interopRequireDefault(require("./backgroundAdded"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }